export const splitTimesConfig = {

  /** Pozicie medzicasov */
  splitTimePositions: [0.2],

  /** Pozicia zvonenia posledneho kola */
  lastRoundBellPosition: 0.18

}
